import type { KeyboardEvent } from 'react';

export const preventFormSubmitOnEnterKeyPress = (event: KeyboardEvent<HTMLElement>): void => {
	event.key === 'Enter' && event.preventDefault();
};
